import { useState } from 'react'
import { useDeleteDocument } from '@/features/chat/documents/useDocumentMutations'
import { DOCUMENT_MENU_ACTION } from './documentsRowMenuConfig'

export function useDocumentsTableMenu() {
  const [menuAnchor, setMenuAnchor] = useState(null)
  const [menuDocumentId, setMenuDocumentId] = useState(null)
  const deleteDocument = useDeleteDocument()

  const openMenu = Boolean(menuAnchor)

  const handleOpenMenu = (event, documentId) => {
    event.stopPropagation()
    setMenuAnchor(event.currentTarget)
    setMenuDocumentId(documentId)
  }

  const handleCloseMenu = () => {
    setMenuAnchor(null)
    setMenuDocumentId(null)
  }

  const handleSelectMenuItem = (action) => {
    if (action !== DOCUMENT_MENU_ACTION.DELETE) return
    if (!menuDocumentId) return
    if (!window.confirm('Delete this document? This cannot be undone.')) return false
    deleteDocument.mutate(menuDocumentId)
  }

  return {
    openMenu,
    menuAnchor,
    menuDocumentId,
    handleOpenMenu,
    handleCloseMenu,
    handleSelectMenuItem,
  }
}
